var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 35,
    viewBox: "0 0 113 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.304 3.12318L112.55 1.87995L111.304 0.636719L110.058 1.87995L111.304 3.12318Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.304 18.7516L112.55 17.5084L111.304 16.2651L110.058 17.5084L111.304 18.7516Z",
    fill: "#0033CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.304 34.3799L112.55 33.1366L111.304 31.8934L110.058 33.1366L111.304 34.3799Z",
    fill: "#0033CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6371 3.12318L96.8834 1.87995L95.6371 0.636718L94.3908 1.87995L95.6371 3.12318Z",
    fill: "#0033CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6371 18.7516L96.8833 17.5084L95.6371 16.2651L94.3908 17.5084L95.6371 18.7516Z",
    fill: "#0033CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6371 34.3799L96.8833 33.1366L95.6371 31.8934L94.3908 33.1366L95.6371 34.3799Z",
    fill: "#0033CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9702 3.12317L81.2165 1.87995L79.9702 0.636717L78.724 1.87995L79.9702 3.12317Z",
    fill: "#0033CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9702 18.7516L81.2165 17.5084L79.9702 16.2651L78.724 17.5084L79.9702 18.7516Z",
    fill: "#0033CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9702 34.3799L81.2165 33.1366L79.9702 31.8934L78.724 33.1366L79.9702 34.3799Z",
    fill: "#0033CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3034 3.12317L65.5497 1.87995L64.3034 0.636717L63.0571 1.87995L64.3034 3.12317Z",
    fill: "#0033CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3034 18.7516L65.5497 17.5084L64.3034 16.2651L63.0571 17.5084L64.3034 18.7516Z",
    fill: "#0033CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3034 34.3799L65.5497 33.1366L64.3034 31.8934L63.0571 33.1366L64.3034 34.3799Z",
    fill: "#0033CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6368 3.12317L49.8831 1.87994L48.6368 0.636716L47.3905 1.87994L48.6368 3.12317Z",
    fill: "#0033CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6368 18.7516L49.8831 17.5084L48.6368 16.2651L47.3905 17.5084L48.6368 18.7516Z",
    fill: "#0033CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6368 34.3799L49.8831 33.1366L48.6368 31.8934L47.3905 33.1366L48.6368 34.3799Z",
    fill: "#0033CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9699 3.12317L34.2162 1.87994L32.9699 0.636715L31.7237 1.87994L32.9699 3.12317Z",
    fill: "#0033CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9699 18.7516L34.2162 17.5084L32.9699 16.2651L31.7237 17.5084L32.9699 18.7516Z",
    fill: "#0033CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9699 34.3799L34.2162 33.1366L32.9699 31.8934L31.7237 33.1366L32.9699 34.3799Z",
    fill: "#0033CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3031 3.12317L18.5494 1.87994L17.3031 0.636715L16.0568 1.87994L17.3031 3.12317Z",
    fill: "#0033CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3031 18.7516L18.5494 17.5084L17.3031 16.2651L16.0568 17.5084L17.3031 18.7516Z",
    fill: "#0033CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3031 34.3799L18.5494 33.1366L17.3031 31.8934L16.0568 33.1366L17.3031 34.3799Z",
    fill: "#0033CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63666 3.12317L2.88293 1.87994L1.63666 0.636714L0.390366 1.87994L1.63666 3.12317Z",
    fill: "#0033CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63666 18.7516L2.88293 17.5084L1.63666 16.2651L0.390365 17.5084L1.63666 18.7516Z",
    fill: "#0033CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63666 34.3799L2.88293 33.1366L1.63666 31.8934L0.390364 33.1366L1.63666 34.3799Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeDot);
export default __webpack_public_path__ + "static/media/tree-dot.69a494b0aa4bd046b6924c9469e61cf3.svg";
export { ForwardRef as ReactComponent };